// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3UrKw","errorLogs":"EditorFooter_errorLogs__1NfCw"};